import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-lot-add-photo-uploading-list-item-preview',
  templateUrl: './lot-add-photo-uploading-list-item-preview.component.html',
  styleUrls: ['./lot-add-photo-uploading-list-item-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoUploadingListItemPreviewComponent {
  @Input() image: string;
  @Input() isAuctionList = false;
  @Output() remove = new EventEmitter<void>();
  @Output() openPreview = new EventEmitter<void>();
  @Output() setAsAuctionList = new EventEmitter<void>();
}
